import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import AppLogo from "../../assets/images/logo.svg";
import LayoutLogo from "../../assets/images/topDesign.svg";
import "../..//App.css";
import TextInputLable from "../../components/textField";
import PasswordArea from "../../components/passwordField";
import LeftSideImage from "../../commonUses/leftSideImage";
import MailIcon from "../../assets/images/mailIcon.svg";
import LockIcon from "../../assets/images/lockIcon.svg";
import { useNavigate } from "react-router-dom";
import { loginApi } from "../../api/adminApi";
import { Helmet } from "react-helmet-async";
import { Link } from "@mui/material";
import { StyledSubmitButton } from "../../StyledComponents/StyledComponents";

export default function SignInSide() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [formError, setFormError] = useState("");
  const handleEmailChange = (e) => {
    const inputValue = e.target.value;
    setEmail(inputValue);
    setEmailError("");
    setFormError("");
  };

  const handlePasswordChange = (e) => {
    const inputValue = e.target.value;
    setPassword(inputValue);
    setPasswordError("");
    setFormError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let hasError = false;

    if (!email) {
      setEmailError("Please enter email");
      hasError = true;
    }
    if (!password) {
      setPasswordError("Please enter password");
      hasError = true;
    }

    if (hasError) return;

    let credantial = {
      email,
      password,
    };
    let apiData = await loginApi(credantial);
    
    if (apiData?.data?.statusCode === 200 || apiData?.data?.success === true) {
      navigate("/Dashboard");
      setPasswordError("");
      setEmailError("");
      setFormError("");
      return;
    }

    const errorMessage = apiData?.data?.message || "An error occurred during login";
    switch (errorMessage) {
      case "Invalid Email":
      case "Invalid Password":
      case "Invalid admin credentials.":
      case "Email and password are required fields.":
        setFormError("Incorrect email or password. Please try again.");
        break;
      case "you don't have an access.contact your admin":
        setFormError("Access Denied");
        break;
      default:
        setFormError(errorMessage);
        break;
    }
  };

  const [showPassword, setShowPassword] = useState(false);
  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  let regex = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/;
  var textFieldColor = regex.test(email)
    ? emailError === ""
      ? "#FBF5FF"
      : "white"
    : "white";
  var passwordColor =
    password.length > 7
      ? passwordError === ""
        ? "#FBF5FF"
        : "white"
      : "white";

  var styles;
  if (showPassword === true) {
    styles = {
      color: "#8B8B8B",
    };
  } else {
    styles = {
      color: "#CBCBCB",
    };
  }
  var imageVisible;
  if (email.length < 1) {
    imageVisible = MailIcon;
  } else {
    imageVisible = null;
  }
  var passwordVisible;
  if (password.length < 1) {
    passwordVisible = LockIcon;
  } else {
    passwordVisible = null;
  }
  return (
    <>
      <Helmet>
        <title> Duco Insure </title>
      </Helmet>
      <Grid container component="main" sx={{ height: "100vh" }}>
        <LeftSideImage />
        <Grid item xs={12} sm={12} md={12} lg={5}>
          <img src={LayoutLogo} alt="Layout" style={{ float: "right" }} />

          <Grid container direction="column" alignItems="center" rowGap={3}>
            <Grid item>
              <img src={AppLogo} alt="AppLogo" />
            </Grid>
            <Grid item>
              <Typography component={"span"} variant={"body2"}>
                <p className="topFont">Welcome Back!</p>
              </Typography>
            </Grid>
            <Grid item>
              <Typography component={"span"} variant={"body2"}>
                <p className="topNextText">Sign In</p>
              </Typography>
            </Grid>
            {formError && (
              <Grid item>
                <Typography component="div" sx={{ color: "#d32f2f", fontSize: "14px", fontWeight: 500 }}>
                  {formError}
                </Typography>
              </Grid>
            )}
            <Grid item>
              <form onSubmit={handleSubmit}>
                <Grid container direction={"column"} rowSpacing={3}>
                  <Grid item>
                    <label className="lableText">Email Address<span style={{ color: "red" }}>*</span></label>
                    <TextInputLable
                      email={email}
                      emailChange={handleEmailChange}
                      error={Boolean(emailError)}
                      helperText={emailError}
                      imageVisible={imageVisible}
                      textFieldColor={textFieldColor}
                    />
                  </Grid>
                  <Grid item>
                    <label className="lableText">Password<span style={{ color: "red" }}>*</span></label>
                    <PasswordArea
                      show={showPassword}
                      password={password}
                      handlePasswordChange={handlePasswordChange}
                      error={Boolean(passwordError)}
                      helperText={passwordError}
                      onClick={handleTogglePasswordVisibility}
                      styleColor={styles}
                      passwordVisible={passwordVisible}
                      passwordColor={passwordColor}
                    />
                  </Grid>
                  <Grid item>
                    <StyledSubmitButton type="submit" fullWidth>
                      Sign in
                    </StyledSubmitButton>
                  </Grid>
                </Grid>
              </form>
            </Grid>
            <Link href="sendOtp">Change Password!</Link>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
